export {
	triggerEvent
};

// clickイベントをjsで再現
// ブラウザによって方法が異なるためその差異を吸収
function triggerEvent(element, event) {
	if (!element) return;

	if (typeof element.click === "function") {
		element.click();
	} else {
		const evt = document.createEvent("HTMLEvents");
		evt.initEvent(event, true, true);
		return element.dispatchEvent(evt);
	}
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/modules/browser-util.js